<template>
  <FormField
    :id="input?.id"
    :class="classField"
    :label="label"
    :isLabelVisible="isLabelVisible"
    :isError="isError"
    :errorMessage="errorMessage"
  >
    <textarea
      v-uid
      v-bind="$attrs"
      :value="modelValue"
      :disabled="isDisabled"
      :maxLength="maxLength"
      :class="{
        isError,
        isDisabled
      }"
      @input="updateValue"
    />
    <template #bottomEnd>
      <div v-if="maxLength" class="self-end text-neutral-500">
        {{ modelValue.length }} / {{ maxLength }}
      </div>
    </template>
  </FormField>
</template>

<script lang="ts">
export default {
  inheritAttrs: false
}
</script>

<script setup lang="ts">
interface InputProps {
  classField?: string
  label: string
  isLabelVisible?: boolean
  modelValue?: string
  isDisabled?: boolean
  isError?: boolean
  errorMessage?: string
  maxLength?: number
}

withDefaults(defineProps<InputProps>(), {
  isLabelVisible: true,
  modelValue: '',
  isDisabled: false,
  isError: false,
  maxLength: 2000
})

const emit = defineEmits(['update:modelValue'])

const updateValue = (e: Event) => {
  emit('update:modelValue', (e.target as HTMLInputElement).value)
}

const input = ref<null | HTMLElement>(null)
</script>
